import sanitizeHtml from 'sanitize-html';
(function(){
    
    var BloomRates = function(elements){
        this.elements = elements;
        this.table_names =[];
        this.initBloomRates();

    }

    BloomRates.prototype.initBloomRates = function(overwrite = false){
        let base_url = '/wp-json/base/v1/rates';
        let table_names = [];
        let that = this;

        for (let i = 0; i < this.elements.length; i++) {
            let table_name = this.elements[i].getAttribute('data-table-slug');
            if (overwrite === false && this.elements[i].getAttribute('data-table-loaded') == 'true') {
                continue;
            }
            if( ! table_names.includes(table_name)){
                this.table_names.push(table_name);
            }
        }

        table_names = JSON.stringify(this.table_names);
        const params = new URLSearchParams({ q: table_names });
        fetch(`${base_url}?${params.toString()}`)
        .then((response)=>response.json())
        .then((data)=>{
            that.data = data;
            
            for (let i = 0; i < that.data.length; i++) {
                let selector = that.data[i].title;
                let table = that.data[i].table;
                
                that.elements.forEach(function(placeholder){
                    let selector_matches = placeholder.getAttribute('data-table-slug') === selector;
                    let write_value = ! (overwrite === false && placeholder.getAttribute('data-table-loaded') == 'true')
                    if (selector_matches && write_value) {
            
                        let row = placeholder.getAttribute('data-table-row');
                        let col = placeholder.getAttribute('data-table-col');
                        let table_body = table.body;
                        
                        placeholder.innerHTML = sanitizeHtml(that.getValueAtCoords(row, col, table_body));
                        placeholder.setAttribute('data-table-loaded', 'true');
                    }
                })
                
                
            }
            
        });
    }
    BloomRates.prototype.getValueAtCoords = function(row, col, table) {
        col = this.getColumnIndexFromString(col);
        row = row - 1;
        
        if (
            typeof table[row] !== 'undefined'
            && typeof table[row][col] !== 'undefined'
            && typeof table[row][col]['c'] !== 'undefined'
        ) {
           
            return table[row][col]['c'];
        }
        return '';
    }
    /**
     * Lookup array index using Excel-like base 26 keys, i.e. "A", "a", "AA"
     * @param {*} str 
     * @returns 
     */
    BloomRates.prototype.getColumnIndexFromString = function(str) {
        str = str.toUpperCase();
        let out = 0, len = str.length;
        for (let pos = 0; pos < len; pos++) {
          out += (str.charCodeAt(pos) - 64) * Math.pow(26, len - pos - 1);
        }
        return out - 1;
    }  

    let rate_placeholders = document.querySelectorAll('.js-bloom-rate');
    window.BloomRates = new BloomRates(rate_placeholders);
    
})();
